export const CORRECT = 'CORRECT';
export const WRONG = 'WRONG';